import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'progressPercent',
  standalone: true
})
export class ProgressPercentPipe implements PipeTransform {
  transform(steps: { status: string }[]): number {
    if (!steps || steps.length === 0) return 0;
    const completed = steps.filter(s => s.status === 'completed').length;
    const hasActive = steps.some(s => s.status === 'started');
    // Each completed step is a full unit; an active step counts as half
    const progress = completed + (hasActive ? 0.5 : 0);
    return Math.min(Math.round((progress / steps.length) * 100), 100);
  }
}
